import { ReactElement } from 'react'
import { ContactClassifier } from '../../constants'
import { DurationField } from './classifiers/DurationField'
import { MetadataField } from './classifiers/MetadataField'
import { RandomField } from './classifiers/RandomField'
import { ScoreField } from './classifiers/ScoreField'
import { ReasonField } from './classifiers/ReasonField'
import { ClassifierTextField } from './classifiers/ClassifierTextField'
import { ChannelField } from './classifiers/ChannelField'
import { SentimentField } from './classifiers/SentimentField'

export interface ClassifierFieldProps {
  classifier?: ContactClassifier,
  field?: ClassifierFieldType,
  onChange: (value: ClassifierFieldType) => void,
}

export interface ClassifierFieldType {
  classifierType: number,
  field: string | null,
  fieldKey: string | null,
  name: string,
}

export const ClassifierField = ({ classifier, ...props }: ClassifierFieldProps): ReactElement => {
  if (!classifier) {
    return (<></>)
  }

  switch (classifier.id) {
    case 1:
    case 2: {
      return (
        <>
          <DurationField key={classifier.id} classifier={classifier}  {...props} />
        </>
      )
    }
    case 5:
    case 6:
      return (
        <>
          <MetadataField key={classifier.id} classifier={classifier} {...props} />
        </>
      )
    case 10:
    case 11:
    case 12:
    case 19:
    case 20:
      return (
        <>
          <RandomField key={classifier.id} classifier={classifier} {...props} />
        </>
      )
    case 13:
      return (
        <>
          <ReasonField key={classifier.id} classifier={classifier} {...props} />
        </>
      )
    case 15: //Predictive Net Promoter Score Less Than
    case 16: //Predictive Net Promoter Score Greater Than
    case 17: //Predictive Eval Score Less Than
    case 18: //Predictive Eval Score Greater Than
      return (
        <>
          <ScoreField key={classifier.id} classifier={classifier} {...props} />
        </>
      )

    case 7:
    case 8:
    case 9: {
      // Email
      return <ClassifierTextField key={classifier.id} classifier={classifier} {...props} />
    }
    // case 11:  Random Email
    // case 12: Random Text
    // case 13: Random Chat, SMS
    // case 19:  Reason Chat
    // case 20:   Reason SMS
    case 21:
      return (
        <>
          <ChannelField key={classifier.id} classifier={classifier} {...props} />
        </>
      )
    case 22:
    case 23:
      return (
        <>
          <SentimentField key={classifier.id} classifier={classifier} {...props} />
        </>
      )
    default:
      return <span>no changes need</span>
  }
}
